export function StageFeedback({ note }: { note: string | null }) {
  if (!note) return null;
  return (
    <div className="mt-4 rounded-lg border border-amber-300 bg-amber-50 dark:border-amber-500/40 dark:bg-amber-900/20 px-4 py-3 text-[0.85rem] text-amber-900 dark:text-amber-200">
      <div className="font-medium mb-0.5">A reviewer asked for changes:</div>
      {note}
    </div>
  );
}

export function ReviewWaitingScreen({ title, body }: { title: string; body: string }) {
  return (
    <div className="max-w-md mx-auto card p-7 lg:p-10 has-grain animate-fade-up text-center">
      <h2 className="h-card mb-2 text-ink-900 dark:text-ink-100">{title}</h2>
      <p className="hint">{body}</p>
    </div>
  );
}
